import React, { useEffect } from "react";
import "./JoinTrend.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import DownloadOnGooglePlay from "../Buttons/DownloadOnGooglePlay";
import DownloadOnAppStore from "../Buttons/DownloadOnAppStore";
import DownloadOnAppStoreMobile from "../Buttons/DownloadOnAppStoreMobile";
import DownloadOnGooglePlayMobile from "../Buttons/DownloadOnGooglePlayMobile";
const JoinTrend = () => {
  const { t } = useTranslation();
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div className="join-trend-container">
      <div className="join-trend-details">
        <div
          className="join-trend-card"
          data-aos="fade-right"
          data-aos-duration="1000"
        >
          <h5>
            {" "}
            {t("Join")} {t("The")} {"Trend"}
          </h5>
          <h3>
            {" "}
            {t("Welcome")} {t("to")} {t("the")} {t("world")} {t("of")}{" "}
            {t("possibilities")} {t("in")} {t("the")} {t("web3")} {t("space")}.
          </h3>
          <div className="join-trend-buttons">
            <DownloadOnGooglePlay />
            <DownloadOnGooglePlayMobile />
          </div>
        </div>
        <div
          className="join-trend-card"
          data-aos="fade-left"
          data-aos-duration="1000"
        >
          <h5>
            {t("Dont")} {t("be")} {t("left")} {t("behind")}{" "}
          </h5>
          <h3>
            GameFi {t("is")} {t("no")} {t("longer")} {t("the")} {t("next")}{" "}
            {t("big")} {t("thing")}. {t("It")} {t("is")} {t("the")}{" "}
            {t("present")} {t("big")} {t("thing")}.
          </h3>
          <div className="join-trend-buttons">
            <DownloadOnAppStore />
            <DownloadOnAppStoreMobile />
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinTrend;
